function initialState() {
  return { list: null }
}

export default {
  RESET_STORE(state) {
    const newState = initialState()
    state = Object.assign(state, newState)
  },

  SET_LIST(state, list) {
    list.every(function(v) {
      v.media = v.media && v.media.data ? v.media.data : v.media ? v.media : []
      v.scans = v.scans && v.scans.data ? v.scans.data : v.scans ? v.scans : []
      // v.travelingHome = localStorage.getItem('isTravelingHome') ? localStorage.getItem('isTravelingHome') : false
      return v
    })
    state.list = _.extend(list, state.list)
  },

  SET_CALL(state, payload) {
    payload.media =
      payload.media && payload.media.data
        ? payload.media.data
        : payload.media
        ? payload.media
        : []
    payload.scans =
      payload.scans && payload.scans.data
        ? payload.scans.data
        : payload.scans
        ? payload.scans
        : []
    _.extend(_.find(state.list, { id: payload.id }), payload)
  },

  ADD_CALL(state, call) {
    state.list.push(call)
  },

  ACCEPT_CALL(state, payload) {
    _.extend(_.find(state.list, { id: payload.id }), payload)
  },

  TRAVEL_CALL(state, payload) {
    _.extend(_.find(state.list, { id: payload.id }), payload)
  },

  ARRIVED_CALL(state, payload) {
    _.extend(_.find(state.list, { id: payload.id }), payload)
  },

  ARRIVAL_COMPLETED_CALL(state, payload) {
    _.extend(_.find(state.list, { id: payload.id }), payload)
  },

  ONSITE_ARRIVAL_PROCESS(state, payload) {
    _.extend(_.find(state.list, { id: payload.id }), payload)
  },

  RESET_CALL(state, payload) {
    localStorage.removeItem('isTravelingHome')
    _.extend(_.find(state.list, { id: payload.id }), payload)
  },

  COMPLETE_CALL(state, payload) {
    // let item = state.list.find(call => call.id === callId);
    // state.list.splice(state.list.indexOf(item), 1);
    const callId = payload.id
    localStorage.removeItem('isTravelingHome')
    state.list = _.without(
      state.list,
      _.find(state.list, {
        id: parseInt(callId)
      })
    )
  },

  DEPART_CALL(state, payload) {
    _.extend(_.find(state.list, { id: payload.id }), payload)
  },

  ENDTRAVEL_CALL(state, payload) {
    _.extend(_.find(state.list, { id: payload.id }), payload)
  },

  ADD_MEDIA(state, payload) {
    const item = _.find(state.list, val => {
      return val.id === payload.id
    })
    if (item.media && item.media.data) {
      item.media.data.push(payload.media)
    } else if (item.media) {
      item.media.push(payload.media)
    }
  },

  UPDATE_MEDIA(state, payload) {
    const collection_name = payload.collection_name || 'media'
    const item = _.find(state.list, val => {
      return val.id === payload.objectId
    })
    const media = _.find(
      collection_name === 'media' ? item.media : item.scans,
      val => {
        return val.id === payload.mediaId
      }
    )
    if (media) {
      _.extend(media, payload.media)
    }
  },

  REPLACE_MEDIA(state, payload) {
    const collection_name = payload.collection_name || 'media'
    state.list = _.map(state.list, item => {
      if (item.id === payload.objectId) {
        item[collection_name === 'media' ? 'media' : 'scans'] = _.map(
          collection_name === 'media' ? item.media : item.scans,
          media => {
            if (media.id === payload.mediaId) {
              media = payload.media
            }
            return media
          }
        )
      }
      return item
    })
  },

  DELETE_MEDIA(state, payload) {
    const item = _.find(state.list, val => {
      return val.id === payload.callId
    })
    item.media = _.filter(item.media, val => {
      return val.id !== payload.mediaId
    })
  },

  SET_UPLOAD_PROGRESS(state, uploadProgress) {
    if (state.networkStatus === 'offline' && uploadProgress !== undefined)
      return
    state.uploadProgress = uploadProgress
  },

  SET_NETWORK_STATUS(state, status) {
    state.networkStatus = status
  },
  SET_AXIOS_CANCEL_TOKEN(state, token) {
    state.axiosRequest = token
  },

  UPDATE_SIGNATURE(state, payload) {
    const call = _.find(state.list, val => {
      return val.id === parseInt(payload.callId)
    })
    if (!call) {
      return
    }
    if (!payload.type) {
      console.log('no signature type!!!')
      return
    }
    const s = call.signature[payload.type] || { data: {} }
    s.data.src = payload.src
    s.data.url = payload.url
    call.signature[payload.type] = s
  },

  ADD_SCAN(state, payload) {
    const item = state.list.find(item => item.id === payload.id)
    item.scans.push(payload.media)
  },
  UPDATE_SCAN(state, payload) {
    const item = state.list.find(item => item.id === payload.callId)
    const scan = item.scans.find(item => item.id === payload.id)
    scan[payload.optPath] = payload.optVal
  },

  DELETE_SCAN(state, payload) {
    const item = _.find(state.list, val => {
      return val.id === payload.callId
    })
    item.scans = _.filter(item.scans, val => {
      return val.id !== payload.mediaId
    })
  },

  VISIT_STATUS(state, payload) {
    const item = state.list.find(call => call.id === payload.callId)
    item['visit_status'] = payload.status
  },

  TRAVEL_START_TIME(state, payload) {
    const item = _.find(state.list, val => {
      return val.id === payload.callId
    })
    item['travel_started_at'] = payload.dateTime
  },

  ON_SITE_TIME(state, payload) {
    const item = _.find(state.list, val => {
      return val.id === payload.callId
    })
    item['arrived_at'] = payload.dateTime
  },

  OFF_SITE_TIME(state, payload) {
    const item = _.find(state.list, val => {
      return val.id === payload.callId
    })
    item['completed_at'] = payload.dateTime
  },

  TRAVEL_END_TIME(state, payload) {
    const item = _.find(state.list, val => {
      return val.id === payload.callId
    })
    item['travel_ended_at'] = payload.dateTime
  },

  TRAVELING_HOME(state, payload) {
    const item = _.find(state.list, val => {
      return val.id === payload.callId
    })
    // localStorage.setItem('isTravelingHome', payload.travelingHome)
    item['traveling_home'] = payload.travelingHome
  },

  WORK_CARRIED_OUT(state, payload) {
    const item = state.list.find(call => call.id === payload.callId)
    item['work_description'] = payload.work_description
  },

  CLIENT_NAME(state, payload) {
    const item = state.list.find(call => call.id === payload.callId)
    item['accepted_by_name'] = payload.accepted_by_name
  },

  SET_SENTIMENT(state, payload) {
    const item = state.list.find(call => call.id === payload.callId)
    item['sentiment'] = payload.sentiment
  },

  SET_WHY_SENTIMENT(state, payload) {
    const item = state.list.find(call => call.id === payload.callId)
    item['why_sentiment'] = payload.why_sentiment
  },

  CLIENT_POSITION(state, payload) {
    const item = state.list.find(call => call.id === payload.callId)
    item['accepted_by_position'] = payload.accepted_by_position
  },

  SET_HAS_POWRA(state, payload) {
    state.hasPowra = payload
  },

  SET_HAS_WORKSHEET(state, payload) {
    state.hasWorksheet = payload
  },

  ADD_COMPLETED_CALL_FORM(state, payload) {
    if (!_.find(state.completedCallForms, payload)) {
      state.completedCallForms = _.union(state.completedCallForms, [payload])
    }
  },

  CURRENT_RISK_ASSESSMENT(state, payload) {
    state.currentRiskAssessment = payload
  },

  SAVE_RISK_ASSESSMENT_HAZARDS(state, payload) {
    state.currentRiskAssessment.fields.hazards = []
    _.mapKeys(payload, val => {
      state.currentRiskAssessment.fields.hazards.push(val)
    })
    state.currentRiskAssessment.fields.hazards = _.compact(
      state.currentRiskAssessment.fields.hazards
    )
  },

  SAVE_RISK_ASSESSMENT_CONTROLS(state, payload) {
    state.currentRiskAssessment.fields.controls = []
    _.mapKeys(payload, val => {
      state.currentRiskAssessment.fields.controls.push(val)
    })
    state.currentRiskAssessment.fields.controls = _.compact(
      state.currentRiskAssessment.fields.controls
    )
  },

  SAVE_RISK_ASSESSMENT_HAZARDS_CONTROLS(state, payload) {
    _.extend(state.currentRiskAssessment.fields.hazards_controls, payload)
  },

  SET_FORMS_LIST(state, forms) {
    state.forms = _.extend(forms, state.forms)
  },

  SET_PURCHASE_ORDERS_LIST(state, purchase_orders, call_assignment_id) {
    const item = state.list.find(item => item.id === call_assignment_id)
  },

  UPDATE_FORM_SCHEMAS(state, payload) {
    const { form, value } = payload
    _.set(state.formSchemas, form, value)
  },

  UPDATE_LARAFORM_STORE(state, payload) {
    const { path, value } = payload
    _.set(state.formData, path, value)
  },

  CLEAR_WORKSHEET(state) {
    state.formData['engineer-worksheet'] = null
  },

  CLEAR_COMPLETED_FORMS(state) {
    state.completedCallForms = []
  },

  CLEAR_PO_REQUEST(state) {
    state.formData['purchase-order-request'] = null
  },

  SET_SELECTED_FORM_ID(state, formId) {
    state.selectedFormId = formId
  }
}
